import { useDataGrid } from '@/hooks/useDataGrid';
import { Button, ButtonGroup, IconButton, Menu, MenuButton, MenuItemOption, MenuList, MenuOptionGroup } from '@chakra-ui/react';
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';
import { ResponseType } from '../types';
import { CiSettings } from "react-icons/ci";

export function Pagination({ style }: { style?: any }) {
  const { page, setPage, queryResult, setPerPage, perPage } = useDataGrid();

  if (!queryResult || !queryResult.data) return null;

  const {
    data: { qtdpaginas: totalCount },
  } = queryResult.data as ResponseType;

  const qtdPages = Math.ceil(totalCount);

  const visiblePages = paginationNumbers(qtdPages, page, 4);

  function handleNext() {
    if (page < (qtdPages - 1)) {
      setPage(page + 1);
    }
  }
  
  function handlePrev() {
    if (page >= 1) {
      setPage(page - 1);
    }
  }

  return (
    <ButtonGroup
      padding={'0.5rem'}
      width={'full'}
      size={'sm'}
      bottom={0}
      background={'#fff'}
      borderRadius={'0 0 16px 16px'}
      zIndex={3}
      boxShadow={'3px 2px 5px rgba(100,100,100,.1)'}
      role='tablist'
      borderTop={'1px solid #ccc'}
      {
      ...style
      }
    >
      <Button fontSize={12} onClick={handlePrev} role='tab'>
        <MdChevronLeft />
      </Button>

      {visiblePages.map(function (pageNumber: number, index: number) {
        return (
          <Button
            key={index}
            role='tab'
            onClick={() => setPage(pageNumber)}
            colorScheme={page === pageNumber ? 'facebook' : 'gray'}
          >
            {pageNumber + 1}
          </Button>
        );
      })}

      <Button fontSize={12} onClick={handleNext} role='tab'>
        <MdChevronRight />
      </Button>

      <Menu size={'sm'}>
        <MenuButton
          as={IconButton}
          aria-label='Options'
          icon={<CiSettings />}
          variant='outline'
        />
        <MenuList p={0} mr={0} >
          <MenuOptionGroup defaultValue={String(perPage)} w={'150px'} title='Tamanho da lista' type='radio'>
            <MenuItemOption value='20' onClick={() => setPerPage(20)}>20</MenuItemOption>
            <MenuItemOption value='30' onClick={() => setPerPage(30)}>30</MenuItemOption>
            <MenuItemOption value='40' onClick={() => setPerPage(40)}>40</MenuItemOption>
          </MenuOptionGroup>
        </MenuList>
      </Menu>
    </ButtonGroup>
  );
}

export function paginationNumbers(
  pages: number,
  page: number,
  showMax: number
): number[] {
  const paginationNumbers = [];

  if (pages) {
    let endPage;
    let startPage;

    if (pages <= showMax) {
      startPage = 0;
      endPage = pages;
    } else {
      startPage = page - 3;
      endPage = page + 3;

      if (startPage < 1) {
        startPage = 0;
        endPage = showMax;
      }

      if (endPage > pages) {
        endPage = pages;

        if ((startPage - endPage) <= showMax) {
          startPage = endPage - showMax;
        }
      }
    }
    
    for (let i = startPage; i <= (endPage - 1); i++) {
      paginationNumbers.push(i);
    }

  }
  return paginationNumbers;
}
